import type { Operation } from './types'

/**
 * {@link https://ngrx.io/docs State} of this feature
 *
 * At most one {@link Operation} is present at a time, only while its
 * confirmation is open, and its value tells where that confirmation stands, so
 * opening a confirmation replaces the state instead of merging into it
 *
 * @see {@link State.Status}
 */
export type State = Readonly<Partial<Record<Operation, State.Status>>>

export namespace State {
  /**
   * Where the confirmation of one {@link Operation} stands: empty while it is
   * only being confirmed, then submitting, then possibly failed
   */
  export interface Status {
    /**
     * Failure of the last submit, kept so that the user can try again
     */
    readonly error?: string | Error
    /**
     * Whether the submit is in flight
     */
    readonly isSubmitting?: boolean
  }

  export const INITIAL: State = {}
}
